import React, { Component } from 'react'
import { DropdownToggle } from 'reactstrap';
import { Link } from "react-router-dom";

import {Col, Dropdown, Modal, ModalHeader, ModalBody, Input, Button, Label, FormGroup, Alert} from "reactstrap"
import { AvForm, AvField } from 'availity-reactstrap-validation';
import { victimSourceUrl } from '../../helpers/url';

export default class SourceAdd extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            success: false,
            successMessage: "",
            menu : false,
            modal_center: false,

            sourceId: 0,
            url: "",
            description: ""
        }
        this.tog_center = this.tog_center.bind(this);
    }

    tog_center() {
        this.setState(prevState => ({
          modal_center: !prevState.modal_center
        }));
    }

    submit = () => {
        const session = JSON.parse(sessionStorage.getItem('authUser'));
		const userId = session.payload.sub;
		const accessToken = session.jwtToken;
        fetch(victimSourceUrl, {
            method: "POST",
            headers: {"Content-Type": "application/json", "Authorization": accessToken},
            body: JSON.stringify(
                {
                    sourceId: this.state.sourceId,
                    description: this.state.description,
                    url: this.state.url,
                    victimId: this.props.victimId,
                    userId: userId
                }
            )
        }).then(res=>res.json())
        .then(data => {
            this.setState({
                success: true,
                successMessage: "Submitted! Go back to Testimony Manager and come back again."
            })
        })
    }

    stateHandling = (event) => {
        this.setState({
            [event.target.id]: event.target.value,
        });
    }


    render() {
        if (this.state.loading) {
            return (
                <React.Fragment>
                    <div>
                        LOADING
                    </div>
                </React.Fragment>
            )
        }
        return (
            <React.Fragment>
                <Dropdown className="float-right" isOpen={this.state.menu} toggle={() => this.setState({menu : !this.state.menu})}>
                    <DropdownToggle tag="i" className="darrow-none card-drop" aria-expanded="false">
                        <Link><i className="mdi mdi-book-plus-multiple-outline float-right" onClick={this.tog_center}> Add sources </i></Link>
                        <Modal size="lg" isOpen={this.state.modal_center} toggle={this.tog_center} centered={true} >
                            <ModalHeader toggle={() => this.setState({ modal_center: false })}> Source - Add </ModalHeader>
                            <ModalBody>
                                <AvForm className="form-horizontal" onValidSubmit={this.handleValidSubmit}>
                                    <div className="mt-5 text-center">
                                        <Alert color="success" isOpen={this.state.success} toggle={() => {this.setState({success:!this.state.success, successMessage: ""})}}>
                                            {this.state.successMessage}
                                        </Alert>
                                    </div>
                                    <FormGroup row>
                                        <Label htmlFor="description" md="2" className="form-label">
                                            Source Info (Description)
                                        </Label>
                                        <Col md={8}>
                                            <AvField
                                                type="textarea"
                                                id="description"
                                                name="description"
                                                rows="2"
                                                placeholder="Source Description (What is this source about?)"
                                                value={this.state.description}
                                                onChange={this.stateHandling}
                                                validate={{
                                                    required: { value: true, errorMessage: 'Please enter a description' }
                                                }}
                                            />
                                        </Col>
                                    </FormGroup>
                                    <FormGroup row>
                                        <Label htmlFor="url" md="2" className="form-label">
                                            Source Link (URL)
                                        </Label>
                                        <Col md={8}>
                                            <AvField
                                                type="url"
                                                id="url"
                                                name="url"
                                                placeholder="Source URL"
                                                value={this.state.url}
                                                onChange={this.stateHandling}
                                                validate={{
                                                    required: { value: true, errorMessage: 'Please enter a URL' },
                                                    pattern: { value: 'https?://.+', errorMessage: 'URL must start with http:// or https://' }
                                                }}
                                            />
                                        </Col>
                                    </FormGroup>
                                    <FormGroup row>
                                        <Col md={{ size: 8, offset: 2 }}>
                                            <button type="submit" className="btn btn-primary">Submit</button>
                                        </Col>
                                    </FormGroup>
                                </AvForm>
                            </ModalBody>
                        </Modal>
                    </DropdownToggle>
                </Dropdown>
            </React.Fragment>
        );
    }
}
